import React from 'react';

import { ListIcon } from 'icons';
import { IconButton } from 'netline-ui';
import services from 'services';

const handleOpenMenuClick = () => services.appFrame.mobileNavigation.open();

const MobileNavigationButton = () => {
  return (
    <IconButton data-testid="AppFrame-mobileNavigationButton" aria-label="open menu" onClick={handleOpenMenuClick}>
      <ListIcon />
    </IconButton>
  );
};

export default MobileNavigationButton;
